import { Component, Injector } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { FirestorePathsService, OrdersService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TOrder } from '@shared/models';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Component({
    'selector': 'app-orders',
    'templateUrl': './orders.page.html',
    'styleUrls': ['./orders.page.scss'],
    'standalone': true,
    'imports': [IonicModule, CommonModule, FormsModule, RouterModule]
})
export class OrdersPage extends ViewBasePage implements OnInit, OnDestroy {
    public orders: TOrder[] = [];

    constructor(private activatedRoute: ActivatedRoute, private firestorePathsService: FirestorePathsService,
        private ordersService: OrdersService, injector: Injector) {
        super(injector);
        super.setCurrentView(this.Constants.VIEW_ORDERS);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        const uid = this.activatedRoute.snapshot.paramMap.get('uid');
        const accountNumber = uid;
        this.firestorePathsService.setAccount(accountNumber);

        const orders: TOrder[] = await this.ordersService.getAll();
        this.orders = this.ordersService.sort(orders, false);
        this.orders.forEach((order) => {
            const items = order.items;
            // console.log('order = ', order);
            // console.log('items = ', items);

            // const datetime: string = order.header.createdDate.date;
            // const datetimeParsed = this.utilsService.parseDateTime(datetime);
            // order.header.createdDateFormatted = order.header.createdDate.date;
            // order.header.createdDateFormatted = this.dateService.reformatDateTime(order.header.createdDate.date);
            order.header.totalFormatted = this.utilsService.formatAsCurrency(order.header.total);
        });
    }

    public getPurchasedDate(order: TOrder) {
        const value = order?.header?.createdDate.date;
        if (value) {
            const valueFormatted = this.dateService.formatTimestamp(value, DateTimeFormats.All);
            return valueFormatted;
        } else {
            return '';
        }
    }

    public onOrderClick(uid: string): void {
        this.router.navigateByUrl(`/order/${uid}`);
    }
}
